const fromAppointmentBannerToCampaignInfoBanner = (appointmentBanner)=>{
    let startEndDateCompound;
    if (appointmentBanner === null || appointmentBanner === void 0 ? void 0 : appointmentBanner.startEndDateCompound) {
        /* appointmentBanner.startEndDateCompound contains
      more properties that we dont care about */ const { startDate , endDate  } = appointmentBanner.startEndDateCompound;
        startEndDateCompound = {
            startDate,
            endDate
        };
    }
    return {
        startEndDateCompound,
        bannerIcon: appointmentBanner === null || appointmentBanner === void 0 ? void 0 : appointmentBanner.bannerIcon,
        bannerTitle: appointmentBanner === null || appointmentBanner === void 0 ? void 0 : appointmentBanner.bannerTitle
    };
};
const fromSpotlightedStoresContentToListBlock = (idPrefix, column)=>{
    if (!column || !column.storeBlock) {
        return {
            title: '',
            links: [],
            id: `${idPrefix}-column`
        };
    }
    const { storeBlock  } = column;
    var _store;
    const stores = (_store = storeBlock.store) !== null && _store !== void 0 ? _store : [];
    var ref;
    return {
        title: (ref = storeBlock === null || storeBlock === void 0 ? void 0 : storeBlock.title) !== null && ref !== void 0 ? ref : '',
        id: `${idPrefix}-column`,
        links: stores.filter((item)=>!!item.label
        ).map(({ url , openInNewWindow , label  }, index)=>({
                label,
                url: url !== null && url !== void 0 ? url : undefined,
                openInNewWindow,
                id: `${idPrefix}-${index}-item`
            })
        )
    };
};

export { fromAppointmentBannerToCampaignInfoBanner, fromSpotlightedStoresContentToListBlock };
//# sourceMappingURL=adapters.js.map
